import { TimesInfo } from '../../types'

export const TIMES: TimesInfo[] = [
    { id: 0, timeFrom: 8, timeTo: 20, interval: 'Any time' },
    { id: 1, timeFrom: 8, timeTo: 11, interval: 'Morning' },
    { id: 2, timeFrom: 11, timeTo: 13, interval: 'Noon' },
    { id: 3, timeFrom: 13, timeTo: 17, interval: 'Afternoon' },
    { id: 4, timeFrom: 17, timeTo: 20, interval: 'Evening' }
]

export const TIMES_2: TimesInfo[] = [
    { id: 0, timeFrom: 7, timeTo: 9, interval: 'Morning' },
    { id: 1, timeFrom: 9, timeTo: 11, interval: 'Morning' },
    { id: 2, timeFrom: 11, timeTo: 14, interval: 'Noon' },
    { id: 3, timeFrom: 14, timeTo: 17, interval: 'Afternoon' },
    { id: 4, timeFrom: 17, timeTo: 20, interval: 'Evening' }
]

export const SLIDER_TIMES: any = {
    2: '2AM',
    3: '3AM',
    4: '4AM',
    5: '5AM',
    6: '6AM',
    7: '7AM',
    8: '8AM',
    9: '9AM',
    10: '10AM',
    11: '11AM',
    12: '12PM',
    13: '1PM',
    14: '2PM',
    15: '3PM',
    16: '4PM',
    17: '5PM',
    18: '6PM',
    19: '7PM',
    20: '8PM'
}



// WEBPACK FOOTER //
// ./src/constants/components/pickupTime.ts